import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from 'api/axios';

export const usePackageSearch = (categoryName, categoryId) => {
  return useQuery({
    queryKey: ['packageSearch', categoryName, categoryId],
    queryFn: async () => {
      if (!categoryName && !categoryId) return [];
      const params = { limit: 100, page: 0 };
      if (categoryId) {
        params.category = categoryId;
      } else if (categoryName) {
        params.search = categoryName;
      }
      const { data } = await axiosInstance.get('package/', { params });
      return data?.data?.data ?? [];
    },
    enabled: Boolean(categoryName || categoryId),
    staleTime: 300000,
    retry: false,
  });
};
